import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-complite-registration',
  templateUrl: './complite-registration.component.html',
  styleUrls: ['./complite-registration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CompliteRegistrationComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    let code;
    let userId;
    this.route.queryParams.subscribe((params: Params) => {
      code = params['code'];
      userId = params['userId'];
    });
    if (code !== null && userId !== null) {
      this.authService.ConfirmRegistration(code!, userId!).subscribe();
    }
  }

  GoToLogin() {
    this.router.navigateByUrl('/login');
  }
}
